import EmbedComponentPlugin from './components/EmbedComponentPlugin';
import EmbedPastePlugin from './EmbedPastePlugin';
import EmbedSchemaPlugin from './EmbedSchemaPlugin';

// Plugin for embedded content from other websites, including videos and other
// iframed content.
const EmbedPlugin = [EmbedSchemaPlugin, EmbedComponentPlugin, EmbedPastePlugin];

export default EmbedPlugin;
